import React from "react";
import { createEmptyValidationCheck } from "../factories";
import CustomSelect from "../../../../../../../components/elements/CustomSelect";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faClose} from "@fortawesome/free-solid-svg-icons";
import InputField from "../../../../../../../components/elements/InputField";
import Button from "../../../../../../../components/elements/Button";

const CHECK_KINDS = [
    "stdout_exact", "stdout_regex", "stdout_contains",
    "sql_rows_exact", "sql_columns_match", "dom_selector_exists",
    "dom_attribute_exact", "css_decl_exact", "file_exists"
];

export default function ValidationChecksEditor({ validation, targets, path, updateAtPath }) {
    const { mode, checks } = validation;

    const addCheck = () => {
        updateAtPath([...path, "checks"], [...checks, createEmptyValidationCheck({ targetId: targets[0]?.id || "" })]);
    };

    return (
        <div className="p-5 bg-blue-500 rounded-md">
            <div className="text-white flex justify-between">
                <h3 className='m-5'>Validation Checks</h3>
                <label>
                    Mode
                    <select value={mode} className='px-5 py-3 m-3 text-black rounded-md' onChange={e => updateAtPath([...path, "mode"], e.target.value)}>
                        <option value="all">All (AND)</option>
                        <option value="any">Any (OR)</option>
                    </select>
                </label>
            </div>

            <div className='grid gap-5 p-3'>
                {checks.map((check, idx) => (
                    <div key={idx} className='p-10 text-black bg-white rounded-sm border'>
                        <div className='flex gap-8 items-center'>
                            <CustomSelect
                                options={["Select Target...", ...targets.map(t => t.id)]}
                                value={check.targetId}
                                onChange={e => updateAtPath([...path, "checks", idx, "targetId"], e.target.value)}
                            />

                            <CustomSelect
                                value={check.kind}
                                options={CHECK_KINDS}
                                onChange={e => updateAtPath([...path, "checks", idx, "kind"], e.target.value)}
                            />
                            <div style={{ flex: 1 }} />
                            <Button className='m-5' onClick={() => updateAtPath([...path, "checks"], checks.filter((_, i) => i !== idx))}>
                                <FontAwesomeIcon icon={faClose} size='md' />
                            </Button>
                        </div>

                        {/* Dynamic Builder UI based on Kind */}
                        <div className='grid gap-5 mt-5'>
                            {(check.kind.includes("stdout") || check.kind === "dom_attribute_exact") && (
                               <InputField title={'Expected'} value={check.expected || ""} onChange={e => updateAtPath([...path, "checks", idx, "expected"], e.target.value)} />
                            )}
                            {check.kind.includes("dom") && (
                                <InputField value={check.selector || ""} title={'Selector'} onChange={e => updateAtPath([...path, "checks", idx, "selector"], e.target.value)} />
                            )}
                            {check.kind === "css_decl_exact" && (
                                <>
                                    <InputField value={check.property || ""} title={'Property'} onChange={e => updateAtPath([...path, "checks", idx, "property"], e.target.value)} />
                                    <InputField value={check.value || ""} title={'Value'} onChange={e => updateAtPath([...path, "checks", idx, "value"], e.target.value)} />
                                </>
                            )}
                        </div>
                    </div>
                ))}
                <Button onClick={addCheck}>
                    <span>Add Validation Check</span>
                    <FontAwesomeIcon icon={faAdd} size='md' />
                </Button>
            </div>
        </div>
    );
}
